export default __webpack_public_path__ + "static/media/FiraSans-Italic.0a37de31.woff2";